module.exports = __webpack_public_path__ + "static/img/9.e6fa0c0e.png";